import { Routes, Route } from 'react-router-dom';
import { LoginPage } from '@/features/auth/components/LoginPage';
import { ProtectedRoute } from '@/features/auth/components/ProtectedRoute';
import { NotificationPage } from './NotificationPage';

export function Router() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <NotificationPage />
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}
